import { AxiosRequestConfig } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { CategoriaFinanceiraItem } from "../typings";
export type { CategoriaFinanceiraItem } from "../typings";

export default function useListFinancialCategory(tenant?: string) {
  const url: string = "/v1/categoria-financeira";
  const config: AxiosRequestConfig = {
    params: {
      tenant,
    },
  };
  return useQuery(`/v1/categoria-financeira`, async () => {
    const { data } = await http.get<CategoriaFinanceiraItem[]>(url, config);

    return data;
  });
}
